import en from './en.json'
import it from './it.json'

export const monitoringTranslations = {
	en,
	it
} as const
